// Escolhe o título grande conforme o texto que chega do fluxo de pagamento.
function tituloRecusa(mensagem: string): string {
  if (/recusad/i.test(mensagem)) return 'NÃO AUTORIZADO';
  if (/tempo/i.test(mensagem)) return 'TEMPO ESGOTADO';
  if (/cancelad/i.test(mensagem)) return 'COBRANÇA CANCELADA';
  return 'ATENÇÃO';
}

// Tela vermelha de recusa/erro (esgotou, só restam N, recebido menor, cobrança cancelada).
export function TelaRecusa({ mensagem, aoVoltar }: { mensagem: string; aoVoltar: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-danger-600 px-6 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-danger-600">
        <i className="ri-close-line text-5xl" />
      </span>

      <p className="mt-6 text-4xl font-extrabold uppercase leading-tight text-white">
        {tituloRecusa(mensagem)}
      </p>

      <div className="mt-5 w-full max-w-[420px] rounded-3xl bg-white p-5 text-xl font-bold text-foreground-950">
        {mensagem}
      </div>

      <button
        type="button"
        onClick={aoVoltar}
        className="mt-8 flex h-[64px] w-full max-w-[360px] cursor-pointer items-center justify-center whitespace-nowrap rounded-2xl bg-white text-xl font-extrabold text-red-700 transition-colors hover:bg-danger-50"
      >
        Voltar
      </button>
    </div>
  );
}